import { useCallback, useEffect, useRef } from 'react';
// helpers
import {
  analytics,
  getLeadGenSubmitDetail,
  getLeadGenSubmitDetailWH,
  getLeadGenSubmitSuccess,
  getLeadGenSubmitSuccessWH,
} from '../../../utils/analytics';
// ui
import HtmlStringEmbed from '../../molecules/HtmlStringEmbed/HtmlStringEmbed';
// constants
import { CtfLeadGenType, CtfWHLeadGenType } from '../../../utils/constants';
import { isWHEnv, removeKeys } from '@/utils/helper';
import Router, { useRouter } from 'next/router';

// There are 2 ways to use dynamics form:
// 1. Extend outbound marketing forms using code
////// benefits: performance
// https://learn.microsoft.com/en-us/dynamics365/customer-insights/journeys/developer/marketing-form-client-side-extensibility
////// benefits: realtime
// 2. Extend Customer Insights - Journeys marketing forms using code
// https://learn.microsoft.com/en-us/dynamics365/customer-insights/journeys/developer/realtime-marketing-form-client-side-extensibility

export default function DynamicsForm({
  id,
  name,
  content,
  type,
  dynamicScripts,
}) {
  const formRef = useRef();
  const isWH = isWHEnv();
  const { locale } = useRouter();

  const generateFormData = (form) => {
    let formData = new FormData(form);

    for (var pair of formData.entries()) {
      console.log(pair[0] + ": " + pair[1]);
    }

    const obj = Object.fromEntries(formData);

    let keysToRemove = ['firstname', 'lastname', 'emailaddress1', 'mobilephone', 'address1_line1'];
    return removeKeys(obj, keysToRemove);
  }

  const handleSubmit = useCallback((e) => {
    analytics({
      window,
      document,
      detail: getLeadGenSubmitDetail(e, {
        isPromotional: type === CtfLeadGenType.OFFER,
        locale: locale,
      }),
    });
  }, []);

  // const handleSubmitWH = useCallback((e) => {
  //   localStorage.setItem('formSubmit', JSON.stringify(e));
  //   localStorage.setItem('formSubmitdata', JSON.stringify(e.target))
  //   alert('submitting form', e)
  //   analytics({
  //     window,
  //     document,
  //     detail: getLeadGenSubmitDetailWH(e, {
  //       form_type: type,
  //     }),
  //   });

  // }, []);

  const handleSubmitWH = (e) => {
    const forms = e.target;

    const newObject = generateFormData(forms);

    analytics({
      window,
      document,
      detail: getLeadGenSubmitDetailWH(e, {
        ...newObject,
        form_name: type,
        lead_type: type === CtfWHLeadGenType.SIGNUP ? "Sign-up" : "Enquiry",
        lead_enquiry_type: type === CtfWHLeadGenType.SIGNUP ? undefined : type.replace("form", " "),
      }),
    });
  }

  const handlePostSubmit = useCallback(
    ({ detail: { successful: isSuccessful } } = {}) => {
      if (!isSuccessful) return;

      analytics({
        window,
        document,
        detail: getLeadGenSubmitSuccess(null, {
          isPromotional: type === CtfLeadGenType.OFFER,
          locale: locale,
        }),
      });
    },
    []
  );

  // const handlePostSubmitWH = useCallback(
  //   ({ detail: { successful: isSuccessful } } = {}) => {
  //     if (!isSuccessful) return;

      // analytics({
      //   window,
      //   document,
      //   detail: getLeadGenSubmitSuccessWH(null, {
      //     form_type: type,
      //   }),
      // });
  //   },
  //   []
  // );

  const handlePostSubmitWH = (e) => {
    const { detail: { successful: isSuccessfull } } = e;
    if (!isSuccessfull) return;
    const forms = e.target;

    const newObject = generateFormData(forms);
    analytics({
      window,
      document,
      detail: getLeadGenSubmitSuccessWH(null, {
        ...newObject,
        form_name: type,
        lead_type: type === CtfWHLeadGenType.SIGNUP ? "Sign-up" : "Enquiry",
        lead_enquiry_type: type === CtfWHLeadGenType.SIGNUP ? undefined : type.replace("form", " "),
      }),
    });
  }
  useEffect(() => {
    const isRealtimeForm = !window?.MsCrmMkt;
    if (!isRealtimeForm) return;
    console.log('is Realtime form');

    let form = formRef?.current?.querySelector('form');

    const initForm = () => {
      form = formRef?.current?.querySelector('form');
      if (!form) return;
      if(isWH) {
        form.addEventListener('submit', handleSubmitWH);
        form.addEventListener('d365mkt-afterformsubmit', handlePostSubmitWH);
        return;
      }
      form.addEventListener('submit', handleSubmit);
      form.addEventListener('d365mkt-afterformsubmit', handlePostSubmit);
    };
    if (formRef?.current) {
      formRef?.current.addEventListener('d365mkt-afterformload', initForm);
    }

    return () => {
      if (formRef?.current) {
        formRef?.current.removeEventListener('d365mkt-afterformload', initForm);
      }
      if (form) {
        console.log('remove event listener');
        if(isWH) {
          form.removeEventListener('submit', handleSubmitWH);
          form.removeEventListener('d365mkt-afterformsubmit', handlePostSubmitWH);
          return;
        }
        form.removeEventListener('submit', handleSubmit);
        form.removeEventListener('d365mkt-afterformsubmit', handlePostSubmit);
      }
    };
  }, [handlePostSubmit, handleSubmit, handlePostSubmitWH, handleSubmitWH]);

  useEffect(() => {
    const isOutboundForm = !!window?.MsCrmMkt;
    if (!isOutboundForm) return;

    const handlePostSubmitOutbond = () => {
      handlePostSubmit({ detail: { successful: true } });
    };

    const handlePostSubmitOutbondWH = () => {
      handlePostSubmitWH({ detail: { successful: true } });
    };

    if(isWH) {
      MsCrmMkt.MsCrmFormLoader.on('formSubmit', handleSubmitWH);
      MsCrmMkt.MsCrmFormLoader.on('afterFormSubmit', handlePostSubmitOutbondWH);
      return () => {
        MsCrmMkt.MsCrmFormLoader.off('formSubmit', handleSubmitWH);
        MsCrmMkt.MsCrmFormLoader.off('afterFormSubmit', handlePostSubmitOutbondWH);
      };
    }

    MsCrmMkt.MsCrmFormLoader.on('formSubmit', handleSubmit);
    MsCrmMkt.MsCrmFormLoader.on('afterFormSubmit', handlePostSubmitOutbond);

    return () => {
      MsCrmMkt.MsCrmFormLoader.off('formSubmit', handleSubmit);
      MsCrmMkt.MsCrmFormLoader.off('afterFormSubmit', handlePostSubmitOutbond);
    };
  }, [handlePostSubmit, handleSubmit, handlePostSubmitWH, handleSubmitWH]);

  // Reload dynamics365 script after cookie consent change
  useEffect(() => {
    if (!formRef) return;

    if (!dynamicScripts?.length || !Array.isArray(dynamicScripts)) return;
    dynamicScripts.map((src) => {
      const script = document.createElement('script');
      script.src = src;
      script.onload = () => {
        console.log('Dynamics365 form script loaded successfully');
      };
      script.onerror = () => {
        console.error('Failed to load Dynamics365 form script');
      };
      formRef.current.appendChild(script);
    });
  }, [formRef]);

  return (
    <div ref={formRef} id={id} className="h-full w-full">
      <HtmlStringEmbed name={name} content={content} />
    </div>
  );
}
